<template>
  <form @submit.prevent="updateReport">
    <card id="evaluations" ref="evaluationref">
        <div slot="header">
          <h3 class="card-reference pull-right">Reference Nr: <b>{{ model.user.reference_nr }}</b></h3>
          <h2 class="card-title pull-left">Evaluation Grid</h2>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table-bordered table-top-info">
                <tr>
                  <td>
                    <h4 class="mb-1">Grid completed by:</h4>
                    <p class="mb-1">{{ model.evaluator.name }}</p>
                    <p>{{ model.submitted_at }}</p>
                  </td>
                </tr>
            </table>
            <card card-body-classes="table-full-width">
              <table class="table-bordered table-main border-left-0 border-right-0 table-full-width mt-5" cellpadding="20">
                <thead>
                  <th width="50%">Criteria</th>
                  <th width="10%">Maximum Score</th>
                  <th width="10%">Awarded Score</th>
                  <th width="30%">Assessor Comments</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Alignment of the project with the objectives of the BEST 2.0+ Programme.</td>
                    <td>5</td>
                    <td>
                      <el-select class="filter-select mr-2" v-model="model.evaluation_data.scorea" placeholder="Score">
                        <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                      </el-select>
                    </td>
                    <td>
                      <textarea
                        class="form-control"
                        name="evaluation_data.commentsa"
                        v-model="model.evaluation_data.commentsa"
                        :error="getError('evaluation_data.commentsa')"
                        v-validate="'required'"
                        placeholder=""
                      >
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>Extent to which the project is likely to have tangible positive impacts on biodiversity conservation / sustainable use of natural resources / climate change/ ecosystem services.</td>
                    <td>10</td>
                    <td>
                      <el-select class="filter-select mr-2" v-model="model.evaluation_data.scoreb" placeholder="Score">
                        <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                      </el-select>
                    </td>
                    <td>
                      <textarea
                        class="form-control"
                        name="evaluation_data.commentsb"
                        v-model="model.evaluation_data.commentsb"
                        :error="getError('evaluation_data.commentsb')"
                        v-validate="'required'"
                        placeholder=""
                      >
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>Extent to which the project concept will support the implementation of relevant local, territorial, national and regional strategies, the BEST Regional Ecosystem Profile and Investment Strategy.</td>
                    <td>5</td>
                    <td>
                      <el-select class="filter-select mr-2" v-model="model.evaluation_data.scorec" placeholder="Score">
                        <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                      </el-select>
                    </td>
                    <td>
                      <textarea
                        class="form-control"
                        name="evaluation_data.commentsc"
                        v-model="model.evaluation_data.commentsc"
                        :error="getError('evaluation_data.commentsc')"
                        v-validate="'required'"
                        placeholder=""
                      >
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>The feasibility of the proposed approach and the presence of potential risks that could impede implementation.</td>
                    <td>10</td>
                    <td>
                      <el-select class="filter-select mr-2" v-model="model.evaluation_data.scored" placeholder="Score">
                        <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                      </el-select>
                    </td>
                    <td>
                      <textarea
                        class="form-control"
                        name="evaluation_data.commentsd"
                        v-model="model.evaluation_data.commentsd"
                        :error="getError('evaluation_data.commentsd')"
                        v-validate="'required'"
                        placeholder=""
                      >
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>The extent to which the project identifies all relevant stakeholders and has adequately considered them in the design and implementation.</td>
                    <td>5</td>
                    <td>
                      <el-select class="filter-select mr-2" v-model="model.evaluation_data.scoree" placeholder="Score">
                        <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                      </el-select>
                    </td>
                    <td>
                      <textarea
                        class="form-control"
                        name="evaluation_data.commentse"
                        v-model="model.evaluation_data.commentse"
                        :error="getError('evaluation_data.commentse')"
                        v-validate="'required'"
                        placeholder=""
                      >
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>The likely sustainability of the project concept and the potential for replication.</td>
                    <td>5</td>
                    <td>
                      <el-select class="filter-select mr-2" v-model="model.evaluation_data.scoref" placeholder="Score">
                        <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                      </el-select>
                    </td>
                    <td>
                      <textarea
                        class="form-control"
                        name="evaluation_data.commentsf"
                        v-model="model.evaluation_data.commentsf"
                        :error="getError('evaluation_data.commentsf')"
                        v-validate="'required'"
                        placeholder=""
                      >
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>40</td>
                    <td>{{ totalScore }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <div class="form-group upload-field">
                <span class="file-caption" v-if="!model.files.evaluation_data.evg_evaluation_report">UPLOAD EVALUATION REPORT</span>
                <upload-file
                  v-if="initialized"
                  v-model="model.files.evaluation_data.evg_evaluation_report"
                  class="upload-file"
                  :file-data="model.files.evaluation_data.evg_evaluation_report"
                  :is-editable="isEditable"
                  :is-summary="true"
                  section="evaluation_data.evg_evaluation_report"
                  >
                </upload-file>
              </div>
            </card>
            <div v-if="isEditable" class="card-footer">
              <slot name="footer">
                <div class="pull-right">
                  <base-button wide @click.native="submitReport">SUBMIT</base-button>
                </div>

                <div class="pull-left">
                  <base-button
                    wide
                    type="primary"
                    native-type="submit"
                  >
                    SAVE PROGRESS
                  </base-button>
                </div>
                <div class="clearfix"></div>
              </slot>
            </div>
          </div>
        </div>
    </card>
  </form>
</template>
<script>
import swal from 'sweetalert2';
import {Table, TableColumn, Select, Option} from 'element-ui';
import {BasePagination, Modal, GenerateReports} from 'src/components';
import {SummaryService, FileUploadService, UserRoles} from '@/services';

export default {
  components: {
    GenerateReports,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal
  },
  data() {
    return {
      initialized: false,
      isEditable: true,
      gridId: parseInt(this.$route.params.gridId),
      userDetails: {},
      loggedUser: {},


      documents: {},
      applicantData: {},
      model:
      {
        summary_id: 0,
        evaluation_data: {
          objectives: {},
          organization_type: {},
        },
        files: {
          evaluation_data: {}
        },
        user: {},
        evaluator: {},
        status: 'DRAFT',
      },
      modalEvaluate: {
        visibility: false,
        application: {}
      }
    };
  },
  methods: {
    async getSummaryGrid(gridId)
    {
      let vm = this;

      await SummaryService.getSummaryGrid(gridId).then(function (response)
      {
        let model = {...vm.model, ...response.data};

        model.evaluation_data.lead_applicant_name = model.evaluation_data.lead_applicant_name || model.user.name;
        model.evaluation_data = {...vm.model.evaluation_data, ...response.data.evaluation_data};

        vm.model = model;

        if (model.status === 'SUBMITTED' || vm.loggedUser.role === UserRoles.REGIONAL_ADMIN)
        {
          vm.isEditable = false;
        }
      });
    },
    async getItems(page) {
      let vm = this;
      let loader = vm.$loading.show();

      await vm.getSummaryGrid(vm.gridId);

      loader.hide();
    },
    async updateReport()
    {
      let vm = this;
      let isValidForm = true;

      if (isValidForm) {
        let loader = this.$loading.show();
        let updateRequest = SummaryService.updateSummaryGrid(vm.model, vm.gridId);

        await updateRequest.then(() => {
          this.$store.dispatch('Auth/init');
          LocalizationService.init();

        }).catch(() => {

        });

        await vm.uploadFiles();

        loader.hide();

        if (vm.model.status === 'SUBMITTED') {
          await this.showNotification('complete-progress');
          vm.isEditable = false;
        } else {
          await this.showNotification('save-progress');
        }

      }
    },
    async submitReport()
    {
      let vm = this;

      var submitConfirmation = await vm.showPreSubmitNotification().then((result) => {
        return result.value ? true : false;
      });

      if (submitConfirmation) {

        vm.model.status = 'SUBMITTED';

        await vm.updateReport();
        await SummaryService.submitSummaryGrid(vm.gridId).then(() =>
        {
          this.$store.dispatch('Auth/init');
          LocalizationService.init();

        }).catch(() => {

        });

      }

    },
    async uploadFiles() {
      let files = this.model.files;
      let promises = [];
      let vm = this;

      for (var section in files) {
        if (files.hasOwnProperty(section)) {

          for (var subSection in files[section]) {
            if (files[section].hasOwnProperty(subSection)) {

            let fileToUpload = files[section][subSection];
            if (fileToUpload instanceof File) {

              let formData = new FormData();
              formData.append('file', fileToUpload);
              formData.append('section', fileToUpload.section);
              formData.append('grid_id', vm.gridId);
              formData.append('$section', section);
              if (fileToUpload.id) {
                formData.append('id', fileToUpload.id);
              }

              let promise = FileUploadService.uploadSummaryFile({
                summaryId: vm.model.summary_id,
                formData: formData
              }).then(function (response) {
                let fdSection = formData.get('$section');
                let fdSubSection = formData.get('$subSection');

                files[fdSection][subSection] = {
                  id: response.data.id,
                  name: response.data.filename,
                  download: response.data.download
                };

              }).catch(function (error) {
                console.log('err', error);
              })

              promises.push(promise);
            }
          }
          }
        }
      }

      return await Promise.all(promises);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    showPreSubmitNotification() {
      return swal.fire({
        title: this.$t('general.notification__warning'),
        html: 'You are about to submit your evaluation Grid, are you sure?<br />Once you click YES, you cannot go back to your evaluation',
        // html: this.$t('general.notification__pre_submit_evaluation').split("\n").join("<br>"),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-primary btn-fill',
        confirmButtonText: 'YES',
        cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
        cancelButtonText: 'NO',
      })
    },

    async showNotification(type) {
      if (type === 'save-progress') {
        return await swal({
          title: this.$t('general.notification__success'),
          html: 'Your Evaluation Grid has been Saved.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          type: 'success'
        });
      } else if (type === 'complete-progress') {
        return await swal({
          title: this.$t('general.notification__success'),
          html: 'Your Evaluation Grid has been Saved.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          type: 'success'
        });
      }
    },
  },
  computed: {
    totalScore: function () {
      let total = 0;
      let vm = this;

      total += vm.model.evaluation_data.scorea || 0;
      total += vm.model.evaluation_data.scoreb || 0;
      total += vm.model.evaluation_data.scorec || 0;
      total += vm.model.evaluation_data.scored || 0;
      total += vm.model.evaluation_data.scoree || 0;
      total += vm.model.evaluation_data.scoref || 0;

      return total;
    }
  },
  beforeMount()
  {
    let vm = this;

    vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
  },
  mounted() {
    let vm = this;
    vm.getItems();

    vm.initialized = true;
  }
};
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }


  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }

  .table-top-info
  {
    td
    {
      padding: 10px 20px;
    }
  }

  .table-main
  {
    th:first-child
    {
      width: 30%;
    }
  }

  .upload-field
  {
    display: block;
    width: 100%;
    height: 45px;
    padding-left: 10px;
    border: 1px solid #ccc;
    margin-top: 40px;
    line-height: 45px;

    .file-caption
    {
      display: inline-block;
    }

    .upload-file
    {
      float: right;
    }
  }
</style>
